<template>
  <span
    v-if="column.sortable"
    ref="root"
    role="button"
    aria-sort="none"
    tabindex="0"
    :title="tooltip"
    @keydown.space.prevent="onKeyDown"
    @keydown.enter.prevent="onKeyDown"
    v-html="$to(column.label)"
  ></span>
  <span v-else v-html="$to(column.label)"></span>
</template>

<script>
export default {
  name: 'TableHeader',

  props: {
    columns: {
      type: Array,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },

    localeNamespace: {
      type: String,
      required: false,
      default: null,
    },
  },

  computed: {
    tooltip() {
      if (this.$te(this.column.tooltip)) return this.$t(this.column.tooltip);
      if (this.localeNamespace) return this.$tt(`${this.localeNamespace}.orderBy_${this.column.field}`);
      return '';
    },
  },

  mounted() {
    if (!this.column.sortable) return;

    const parent = this.$refs.root.parentElement;
    parent.addEventListener('click', this.onHeaderClick);
  },

  methods: {
    onKeyDown() {
      this.$refs.root.click();
    },

    onHeaderClick() {
      // set aria-sort
      // aria-sort is supposed to be set on the tables headers
      // since these are somewhat hidden away inside vue-good-table
      // we have to do some querying to set things up.
      const headers = this.$refs.root.parentNode.parentNode.parentNode.querySelector('tr').querySelectorAll('th');
      window.console.assert(this.columns.length === headers.length);
      const index = this.columns.indexOf(this.column);
      const header = headers[index];
      const sort = header.getAttribute('aria-sort');

      for (const e of headers) {
        e.setAttribute('aria-sort', 'none');
      }

      switch (sort) {
        case 'ascending':
          header.setAttribute('aria-sort', 'descending');
          break;
        case 'descending':
        default:
          header.setAttribute('aria-sort', 'ascending');
          break;
      }
    },
  },
};
</script>
